import { useState, useEffect } from "react";
import UiButton from "../../common/UiButton/UiButton";
import {
  Drawer,
  Input,
  Row,
  Col,
  Table,
  notification,
  DatePicker,
  Select,
} from "antd";
import "./Style.css";
import { DownOutlined } from "@ant-design/icons";
import moment from "moment";
import {
  getDropdownListPartner,
  searchPartnerDetails,
} from "../../redux/GlobalSearch/action";
import { connect } from "react-redux";
import useSession from "../CustomLogout/useSession";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

const GlobalLeadSearchOnboarding = (props) => {
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [getStatus, setGetStatus] = useState(null);
  const [selectedDate, setSelectedDate] = useState();
  const [filteredData, setFilteredData] = useState(null);
  const handleSessionExpired = useSession();
  const [noData, setNoData] = useState(false);
  const history = useNavigate();

  useEffect(() => {
    props
      .getDropdownList({
        access_token: props.auth?.accessToken?.access_token,
      })
      .then((res) => {
        if (res?.status === 200) {
          setGetStatus(res?.data?.dtoList);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  }, []);

  const statusData =
    getStatus?.length > 0
      ? getStatus.map((el) => {
          return {
            label: el.name,
            value: el.value,
          };
        })
      : [];

  const handleAddEvent = () => {
    setOpen(true);
    setNoData(false);
  };

  const handleStatusMenuClick = (type) => {
    setSelectedStatus(type);
  };

  const handleDateChange = (date, dateString) => {
    setSelectedDate(moment(dateString, "YYYY-MM-DD"));
  };

  const onClose = () => {
    setOpen(false);
    setSearchText(null);
    setSelectedDate(null);
    setSelectedStatus(null);
    setFilteredData(null);
  };

  const handleSearch = () => {
    const foundDataArray = [];
    const searchData = {
      search: searchText ?? null,
      createdOn: selectedDate ?? null,
      partnerFirmStatus: selectedStatus ?? null,
    };

    props
      .searchLeadDetails({
        access_token: props.auth?.accessToken?.access_token,
        values: searchData,
      })
      .then((res) => {
        if (res && res.status === 200) {
          for (const PartnerLeadStatus in res?.data) {
            if (res?.data?.hasOwnProperty(PartnerLeadStatus)) {
              const leadStatus =
                res?.data[PartnerLeadStatus]?.partnerFirmStatus;
              const leadDataArray =
                res?.data[PartnerLeadStatus]?.partnerDtoList || [];

              if (leadDataArray.length > 0) {
                foundDataArray.push({
                  PartnerLeadStatus: leadStatus,
                  PartnerLeadData: leadDataArray,
                });
              }
            }
          }

          setFilteredData(foundDataArray);
          setNoData(false);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
            setFilteredData(null);
            setNoData(true);
          }
        }
      });
  };

  const handleRowClick = (leadId) => {
    props?.state?.userData?.loggedInRoleType === "RM"
      ? history(`/RMDashboard/edit-partner`, {
          state: { partnerFirmId: leadId },
        })
      : history(`/CETDashboard/edit-partner`, {
          state: { partnerFirmId: leadId },
        });
  };

  const columns =
    props?.state?.userData?.loggedInRoleType === "RM"
      ? [
          {
            title: "display code",
            dataIndex: "partnerDisplayCode",
            key: "partnerDisplayCode",
            render: (text) => text || "- - - -",
          },
          {
            title: "Partner Firm Name",
            dataIndex: "partnerFirmName",
            key: "partnerFirmName",
            render: (text) => text || "- - - -",
          },
          {
            title: "signatory Email",
            dataIndex: "signatoryEmail",
            key: "signatoryEmail",
            render: (text) => text || "- - - -",
          },
          {
            title: "Created On",
            dataIndex: "createdOn",
            key: "createdOn",
            render: (timestamp) => moment(timestamp).format("yyyy-MM-DD"),
          },
          {
            title: "signatory full Name",
            dataIndex: "signatoryFullName",
            key: "signatoryLastName",
            render: (text) => text || "- - - -",
          },
        ]
      : [
          {
            title: "Display Code",
            dataIndex: "partnerDisplayCode",
            key: "partnerDisplayCode",
            render: (text) => text || "- - - -",
          },
          {
            title: "Partner Firm Name",
            dataIndex: "partnerFirmName",
            key: "partnerFirmName",
            render: (text) => text || "- - - -",
          },
          {
            title: "Signatory Email",
            dataIndex: "signatoryEmail",
            key: "signatoryEmail",
            render: (text) => text || "- - - -",
          },
          {
            title: "Created On",
            dataIndex: "createdOn",
            key: "createdOn",
            render: (timestamp) => moment(timestamp).format("yyyy-MM-DD"),
          },
          {
            title: "signatory Full Name",
            dataIndex: "signatoryFullName",
            key: "signatoryLastName",
            render: (text) => text || "- - - -",
          },
          {
            title: "Assigned Rm",
            dataIndex: "assignedRmUserName",
            key: "assignedRmUserName",
            render: (text) => text || "- - - -",
          },
        ];

  return (
    <div>
      <UiButton onClick={handleAddEvent} title="ADVANCE SEARCH" />

      <Drawer
        title="Basic Drawer"
        placement="right"
        onClose={onClose}
        open={open}
        className="search-lead-drawer"
      >
        <div className="addpartnerheading pan-sec-res forline">
          <div>
            <h2 className="main-heading">Advance Search</h2>
            <div className="headre-line newHeadre"></div>
          </div>
          <h3 onClick={onClose} className="header-small-text">
            Cancel
          </h3>
        </div>
        <div className="Parennt">
          <Row md={12}>
            <Col className="NeewProp" md={20}>
              <Col md={15} sm={17}>
                <Input
                  className="custom-input"
                  placeholder="Search"
                  value={searchText}
                  onChange={(e) =>
                    setSearchText(e.target.value === "" ? null : e.target.value)
                  }
                  onPressEnter={handleSearch}
                  bordered={false}
                />
              </Col>
              {/* <Col md={4} className="Marg-top">
                <UiDropDown
                  placeholder={
                    <div>
                      Status <DownOutlined style={{ marginLeft: "6px" }} />
                    </div>
                  }
                  data={statusData}
                  onChange={handleStatusMenuClick}
                />
              </Col> */}
              <Col md={4} sm={3} className="Marg-top">
                <Select
                  style={{ width: 135 }}
                  placeholder={
                    <span>
                      Status{" "}
                      <DownOutlined
                        style={{ verticalAlign: "middle", marginLeft: 8 }}
                      />
                    </span>
                  }
                  value={selectedStatus}
                  onChange={handleStatusMenuClick}
                  popupClassName="custom-dropdown-menu"
                  suffixIcon={null}
                  allowClear={true}
                  bordered={false}
                >
                  {statusData.map((status, index) => (
                    <Option
                      key={index}
                      value={status.value}
                      style={{ fontSize: "12px", color: "#a8a8a8" }}
                    >
                      {status.label}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col md={4} sm={4} className="Marg-top">
                <DatePicker
                  placeholder=" Select Date"
                  bordered={false}
                  onChange={handleDateChange}
                  suffixIcon={<DownOutlined />}
                />
              </Col>
            </Col>
            <Col md={3} className="newButton">
              <UiButton onClick={handleSearch} type="submit" title="SEARCH" />
            </Col>
          </Row>
        </div>
        {filteredData !== null && filteredData.length > 0 ? (
          <div>
            {filteredData.map((data, index) => (
              <div key={index}>
                <p className="StatusName">{data?.PartnerLeadStatus}</p>
                {data?.PartnerLeadData?.length > 0 ? (
                  <Table
                    columns={columns}
                    dataSource={data?.PartnerLeadData}
                    pagination={false}
                    bordered={false}
                    rowClassName={() => "row-pointer"}
                    onRow={(record) => ({
                      onClick: () => handleRowClick(record?.partnerFirmId),
                    })}
                  />
                ) : (
                  <p>No partner Found.</p>
                )}
                <div className="Line"></div>
              </div>
            ))}
          </div>
        ) : (
          noData && <p>No Matching Partner Found.</p>
        )}
      </Drawer>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchLeadDetails: (data) => dispatch(searchPartnerDetails(data)),
    getDropdownList: (data) => dispatch(getDropdownListPartner(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    LogoutFlag: state.Logout,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalLeadSearchOnboarding);
